/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { AVM1Object } from '../runtime/AVM1Object';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1Broadcaster } from './AVM1Broadcaster';
import { notImplemented } from '@awayfl/swf-loader';
import { AVM1LoaderHelper } from './AVM1LoaderHelper';
import { alCallProperty } from '../runtime';
var AVM1MovieClipLoader = /** @class */ (function (_super) {
    __extends(AVM1MovieClipLoader, _super);
    function AVM1MovieClipLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1MovieClipLoader.createAVM1Class = function (context) {
        return wrapAVM1NativeClass(context, true, AVM1MovieClipLoader, [], ['loadClip', 'unloadClip', 'getProgress'], null, AVM1MovieClipLoader.prototype.avm1Constructor);
    };
    AVM1MovieClipLoader.prototype.avm1Constructor = function () {
        AVM1Broadcaster.initialize(this.context, this);
    };
    AVM1MovieClipLoader.prototype.loadClip = function (url, target) {
        var _this = this;
        var loadLevel = typeof target === 'number';
        var level;
        var target_mc;
        if (loadLevel) {
            level = target;
            if (level === 0) {
                notImplemented('MovieClipLoader.loadClip at _level0');
                return false;
            }
        }
        else {
            target_mc = this.context.resolveTarget(target);
            if (!target_mc) {
                return false; // target was not found -- doing nothing
            }
        }
        var loaderHelper = new AVM1LoaderHelper(this.context);
        this._loaderHelper = loaderHelper;
        this._target = null;
        if (!url) {
            return false;
        }
        var t = target;
        if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
            url = this.context.globals.SWF_BASE_URL + url;
        }
        loaderHelper.loadMovieAt(url, 'get', t).then(function (mc) {
            if (!mc) {
                console.warn('load - content is null');
                return;
            }
            alCallProperty(_this, 'broadcastMessage', ['onLoadComplete', target]);
            setTimeout(function () {
                alCallProperty(_this, 'broadcastMessage', ['onLoadInit', target]);
            });
        });
        //80pro todo
        /*
        var loaderInfo = loaderHelper.loaderInfo;

        loaderInfo.addEventListener(Event.OPEN, this.openHandler.bind(this));
        loaderInfo.addEventListener(ProgressEvent.PROGRESS, this.progressHandler.bind(this));
        loaderInfo.addEventListener(IOErrorEvent.IO_ERROR, this.ioErrorHandler.bind(this));
        loaderInfo.addEventListener(Event.COMPLETE, this.completeHandler.bind(this));
        loaderInfo.addEventListener(Event.INIT, this.initHandler.bind(this));

        loaderHelper.load(url, null).then(function () {
            var newChild = loaderHelper.content;
            this._target = getAVM1Object(newChild, this.context);

            if (loadLevel) {
                var avm1LevelHolder = this.context.levelsContainer;
                avm1LevelHolder._addRoot(level, newChild);
            } else {
                // TODO fix newChild name to match target_mc
                var parent = target_mc.adaptee.parent;
                var depth = target_mc.adaptee._depth;
                parent.removeChild(target_mc.adaptee);
                parent.addTimelineObjectAtDepth(newChild, depth);
            }
        }.bind(this));
        */
        return true;
    };
    AVM1MovieClipLoader.prototype.unloadClip = function (target) {
        notImplemented('MovieClipLoader.unloadClip');
        /*
        if (!this._loaderHelper) {
            return false; // nothing was loaded by this loader
        }
        var loadLevel: boolean = typeof target === 'number';
        var level: number;
        var target_mc: AVM1MovieClip;
        var originalLoader = this._loaderHelper.loader;
        if (loadLevel) {
            level = <number>target;
            if (level === 0) {
                release || Debug.notImplemented('MovieClipLoader.unloadClip at _level0');
                return false;
            }
            var avm1LevelHolder = this.context.levelsContainer;
            if (avm1LevelHolder._getRootForLevel(level) !== originalLoader.content) {
                return false; // did not load this root
            }
            avm1LevelHolder._removeRoot(level);
        } else {
            target_mc = target ? this.context.resolveTarget(target) : undefined;
            if (!target_mc) {
                return false; // target was not found -- doing nothing
            }
            if (target_mc.adaptee !== originalLoader.content) {
                return false; // did not load this movie clip
            }
            target_mc.unloadMovie();
        }
        this._target = null;
        this._loaderHelper = null;
        // TODO: find out under which conditions unloading a clip can fail
        */
        return true;
    };
    AVM1MovieClipLoader.prototype.getProgress = function (target) {
        notImplemented('AVM1MovieClipLoader.getProgress');
        return 0;
    };
    return AVM1MovieClipLoader;
}(AVM1Object));
export { AVM1MovieClipLoader };
